import { ExportOrderWithAllItemsQuery } from "@saleor/graphql";
import { parseDateString } from "@saleor/utils/date";
import { useFormik } from "formik";
import moment from "moment-timezone";
import { useIntl } from "react-intl";
import * as Yup from "yup";

const getOrderSchema = () => {
  const intl = useIntl();
  const textError = intl.formatMessage({ defaultMessage: "โปรดระบุข้อมูล" });
  const textDateError = intl.formatMessage({
    defaultMessage: `กรุณาเปลี่ยน “Request Date” (ไม่สามารถใส่วันที่ปัจจุบัน หรือวันที่ผ่านมาแล้วได้)`
  });
  const textEtdError = intl.formatMessage({
    defaultMessage:
      "กรุณาเปลี่ยน “ETA” (ไม่สามารถใส่วันที่ก่อนหรือวันเดียวกับ ETD ได้)"
  });
  return Yup.object().shape({
    shipTo: Yup.string().required(textError),
    billTo: Yup.string().required(textError),
    poNo: Yup.string().required(textError),
    requestDate: Yup.date()
      .transform(parseDateString)
      .typeError(textError)
      .min(new Date(), textDateError)
      .required(textError),
    placeOfDelivery: Yup.string().required(textError),
    portOfDischarge: Yup.string().required(textError),
    portOfLoading: Yup.string().required(textError),
    etd: Yup.date()
      .transform(parseDateString)
      .typeError(textError)
      .required(textError),
    eta: Yup.date()
      .transform(parseDateString)
      .typeError(textError)
      .test("greater-than-etd", textEtdError, function(value) {
        const etd = this.resolve(Yup.ref("etd"));
        return value === null || value === undefined || value > etd;
      })
      .required(textError),
    payer: Yup.string().required(textError)
  });
};

const getInitShipTo = dataExportOrder => {
  if (dataExportOrder?.shipTo) {
    return dataExportOrder.shipTo;
  } else if (dataExportOrder?.pi?.shipTo) {
    return dataExportOrder?.pi?.shipTo;
  } else {
    return "";
  }
};

const getInitBillTo = dataExportOrder => {
  if (dataExportOrder?.billTo) {
    return dataExportOrder.billTo;
  } else if (dataExportOrder?.pi?.billTo) {
    return dataExportOrder?.pi?.billTo;
  } else {
    return "";
  }
};

const getRequestDateFromEtd = (pi_etd, etd, requestDate) => {
  if (etd) {
    return moment(etd)
      .subtract(10, "d")
      .format("YYYY-MM-DD");
  } else if (pi_etd) {
    return moment(pi_etd)
      .subtract(10, "d")
      .format("YYYY-MM-DD");
  } else if (requestDate) {
    return requestDate;
  }
  return "";
};

export const getFormik = (
  dataExportOrder: ExportOrderWithAllItemsQuery["exportOrderWithAllItems"]
) =>
  useFormik({
    initialValues: {
      shipTo: getInitShipTo(dataExportOrder),
      billTo: getInitBillTo(dataExportOrder) || "",
      poDate: dataExportOrder?.poDate || "",
      poNo: dataExportOrder?.poNo || "",
      requestDate: getRequestDateFromEtd(
        dataExportOrder?.pi?.etd,
        dataExportOrder?.etd,
        dataExportOrder?.requestDate
      ),
      refPiNo: dataExportOrder?.refPiNo || "",
      usage: dataExportOrder?.usage || "",
      unloadingPoint: dataExportOrder?.unloadingPoint || "",
      placeOfDelivery:
        dataExportOrder?.placeOfDelivery ||
        dataExportOrder?.pi?.placeOfDelivery ||
        "",
      portOfDischarge: dataExportOrder?.portOfDischarge || "",
      portOfLoading: dataExportOrder?.portOfLoading || "",
      noOfContainers: dataExportOrder?.noOfContainers || "",
      uom: dataExportOrder?.uom || "",
      gwUom: dataExportOrder?.gwUom || "",
      etd: dataExportOrder?.etd || dataExportOrder?.pi?.etd || "",
      eta: dataExportOrder?.eta || dataExportOrder?.pi?.eta || "",
      dlcExpiryDate: dataExportOrder?.dlcExpiryDate || "",
      dlcNo: dataExportOrder?.dlcNo || "",
      dlcLatestDeliveryDate: dataExportOrder?.dlcLatestDeliveryDate || "",
      description: dataExportOrder?.description || "",
      payer: dataExportOrder?.payer || "",
      endCustomer: dataExportOrder?.endCustomer || "",
      paymentInstruction: dataExportOrder?.paymentInstruction || "",
      remark: dataExportOrder?.remark || "",
      productionInformation: dataExportOrder?.productionInformation || "",
      internalCommentToWarehouse:
        dataExportOrder?.internalCommentToWarehouse || ""
    },
    onSubmit: () => {
      //
    },
    validationSchema: getOrderSchema()
  });
